import JiraIssueItem from '../Domain/JiraIssueItem.js';
import AuthService from './authService.js';

/** Command strings recognised by the JiraIssue backend to drive the two Development News flows. */
const SEARCH_COMMAND_NEWS_IN_PROGRESS = 'News - In Progress';
const SEARCH_COMMAND_NEWS_DEPLOYED = 'News - Deployed';

class JiraIssueService {
  /**
   * Fetches Jira issues that have a BravoTitle (public-facing developments).
   * @param {string} status - Comma-separated status filter (e.g. "To Do,In Progress,Testing,UAT")
   * @param {string} orderBy - Field to order by
   * @param {string} orderDirection - "Asc" or "Desc"
   * @param {number} pageNumber - Page number
   * @param {number} numberOfElements - Items per page
   */
  static GetJiraIssues(
    singleSearchLineText = '',
    status = '',
    orderBy = 'CreatedDate',
    orderDirection = 'Asc',
    pageNumber = 1,
    numberOfElements = 9999,
    jiraId = '',
    summary = '',
    assignee = '',
    bravoTitle = '',
    bravoDescription = ''
  ) {
    const searchParams = {
      command: '',
      orderBy: orderBy,
      orderDirection: orderDirection,
      pageNumber: pageNumber,
      numberOfElementsOnAPage: numberOfElements,
      searchItem: {
        ...(singleSearchLineText && { singleSearchLineText }),
        ...(jiraId && { jiraId }),
        ...(summary && { summary }),
        ...(assignee && { assignee }),
        ...(status && { status }),
        ...(bravoTitle && { BravoTitle: bravoTitle }),
        ...(bravoDescription && { BravoDescription: bravoDescription }),
      },
    };

    const url = `/api/JiraIssue/GetBySearchParams?searchParams=${JSON.stringify(searchParams)}&clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  /** Fetches planned & in-progress issues */
  static GetPlannedIssues() {
    return JiraIssueService.GetJiraIssues(SEARCH_COMMAND_NEWS_IN_PROGRESS);
  }

  /** Fetches released/done issues */
  static GetReleasedIssues() {
    return JiraIssueService.GetJiraIssues(SEARCH_COMMAND_NEWS_DEPLOYED);
  }

  /** Fetches stat card data from the backend */
  static GetStats() {
    const url = '/api/JiraIssue/GetStats/?clearCache=false';
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null && Array.isArray(itemlist)) {
      return itemlist.map((item) => new JiraIssueItem(item));
    }
    return [];
  }
}

export default JiraIssueService;
